(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    
    if (!customElements.get('product-to-cart')) {
        customElements.define('product-to-cart', class extends Core {
            elements = {
                button: '[data-to-cart]',
                quantityInput: '[data-input]'
            }
            
            subscriptions = {
                'cart:update':  '_cartUpdateHandler',
                'cart:error':  '_cartUpdateHandler'
            }

            render() {
                this.subscribe('cart:update', { global: true });
                this.subscribe('cart:error', { global: true });
                this._handleClick();
                this._handleQuantityChange();
            }

            _handleClick() {
                this.$button.addEventListener('click', this._onClick.bind(this))
            }

            _handleQuantityChange() {
                if (this.$quantityInput) {
                    this.$quantityInput.addEventListener('change', this._onQuantityChange.bind(this));
                }
            }

            _onQuantityChange() {
                console.log("Quantity changed, but no immediate cart action triggered.");
            }

            async _onClick() {
                this.loading = true;
                if (!this.belongsToForm) {
                    const mainProduct = this.cartItem;
                    try {
                        const secondaryProducts = await handleSecondaryProductLogic({ variantId: mainProduct[0].id }, mainProduct[0].quantity);
                        const itemsToAdd = [mainProduct[0]];
                        
                        if (secondaryProducts && secondaryProducts.length > 0) {
                            itemsToAdd.push(...secondaryProducts);
                        }
                        
                        await this.addToCart(itemsToAdd);
                    } catch (error) {
                        console.error("Error adding products to cart:", error);
                        this.publish('cart:error');
                    } finally {
                        this.loading = false;
                    }
                }
            }
     
            addToCart(items) {
                return new Promise((resolve, reject) => {
                    this.publish('cart:add', {
                        items
                    });
                    resolve();
                });
            }

            _cartUpdateHandler() {
                setTimeout(() => {
                    this.loading = false;
                }, 1500);
            }

            get belongsToForm() {
                return this.hasAttribute(ATTR_BELONGS_FORM);
            }

            get cartItem() {
                const quantityInput = this.$quantityInput;
                const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
                return [{ 
                    id: +this.getAttribute(ATTR_VARIANT_ID), 
                    quantity: quantity
                }];
            }
            
            set loading(state) {
                this.$button.classList.toggle(CN_LOADING, state);
            }

            get cartNotificationsEnabled() {
                return window.global.cartNotificationsEnabled;
            }

            set variantId(id) {
                this.setAttribute(ATTR_VARIANT_ID, id);
            }

        });
    }
})();
